import { render, staticRenderFns } from "./hqglMailReceiveInfo.vue?vue&type=template&id=a0fcc50e&scoped=true&"
import script from "./hqglMailReceiveInfo.vue?vue&type=script&lang=js&"
export * from "./hqglMailReceiveInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fcc50e",
  null
  
)

export default component.exports